import { ListValue } from '../../ListValue';

export class ClaimValue {

    static List(): ListValue[] {

        let list: ListValue[] = [
            { "id": "Read", "name": "read" },
            { "id": "Update", "name": "update" },
            { "id": "Create", "name": "create" },
            { "id": "Delete", "name": "delete" },
            { "id": "ForceSend", "name": "force_send" },
            { "id": "Stop", "name": "stop" },
            { "id": "Chat", "name": "chat" },
            { "id": "Action", "name": "action" },
            { "id": "Deactivate", "name": "deactivate" },
            { "id": "UpdateSettings", "name": "update_settings" },
            { "id": "MessageToggleUpdate", "name": "message_toggle_update" },
            { "id": "UpdateLimited", "name": "update_limited" },
            { "id": "AddOrganizationManager", "name":"add_organization_manager"}
        ];

        return list;
    }

    static Name(id: string): string {

        let rtn: string = "";

        ClaimValue.List().forEach(obj => {

            if (obj.id == id) {
                rtn = obj.name;
            }

        });

        return rtn;

    }

    static Value(name: string): string {

        let rtn: string = "";

        ClaimValue.List().forEach(obj => {

            if (obj.name == name) {
                rtn = obj.id;
            }

        });

        return rtn;

    }

}
